import React from 'react'

// 描画中の予期しない例外だけを最後に受け止める。
// バリデーションや業務エラーは各画面の通常UIで案内する前提。
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
    }
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unexpected UI error', error, errorInfo)
  }

  handleReload = () => {
    window.location.href = '/'
  }

  render() {
    const { hasError, error } = this.state

    if (!hasError) return this.props.children

    return (
      <div style={styles.page}>
        <div style={styles.card}>
          <p style={styles.code}>500</p>
          <h1 style={styles.title}>問題が発生しました</h1>
          <p style={styles.text}>
            画面の表示中に予期しないエラーが発生しました。
            <br />
            お手数ですが、トップページから再度お試しください。
          </p>
          {process.env.NODE_ENV === 'development' && error && (
            <pre style={styles.pre}>{error.message}</pre>
          )}
          <button type="button" onClick={this.handleReload} style={styles.button}>
            トップページへ戻る
          </button>
        </div>
      </div>
    )
  }
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: 'linear-gradient(180deg, #f7fafc 0%, #eef2f7 100%)',
  },
  card: {
    width: '100%',
    maxWidth: '560px',
    padding: '32px',
    borderRadius: '16px',
    backgroundColor: '#ffffff',
    boxShadow: '0 20px 45px rgba(27, 39, 51, 0.12)',
    textAlign: 'center',
  },
  code: {
    margin: '0 0 8px',
    fontSize: '14px',
    fontWeight: 700,
    letterSpacing: '0.12em',
    color: '#c05621',
  },
  title: {
    margin: '0 0 16px',
    fontSize: '32px',
    color: '#1a202c',
  },
  text: {
    margin: '0 0 24px',
    lineHeight: 1.7,
    color: '#4a5568',
  },
  pre: {
    overflowX: 'auto',
    padding: '12px',
    margin: '0 0 24px',
    borderRadius: '8px',
    backgroundColor: '#f7fafc',
    color: '#2d3748',
    textAlign: 'left',
  },
  button: {
    padding: '12px 20px',
    border: 0,
    borderRadius: '999px',
    backgroundColor: '#2b6cb0',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 700,
    cursor: 'pointer',
  },
}

export default ErrorBoundary
